/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_SpeakersInputs */

const en_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const fr_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locuteurs`)
};

const de_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher`)
};

const it_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altoparlanti`)
};

const ru_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Докладчики`)
};

const es_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oradores`)
};

const zh_cn2_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者`)
};

const ja_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者`)
};

const hi_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं`)
};

const pt_pt2_quicktools_tab_speakers = /** @type {(inputs: Quicktools_Tab_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palestrantes`)
};

/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Quicktools_Tab_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_speakers = /** @type {((inputs?: Quicktools_Tab_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_speakers(inputs)
	if (locale === "de") return de_quicktools_tab_speakers(inputs)
	if (locale === "it") return it_quicktools_tab_speakers(inputs)
	if (locale === "ru") return ru_quicktools_tab_speakers(inputs)
	if (locale === "es") return es_quicktools_tab_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_speakers(inputs)
	if (locale === "ja") return ja_quicktools_tab_speakers(inputs)
	if (locale === "hi") return hi_quicktools_tab_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_speakers(inputs)
	return en_quicktools_tab_speakers(inputs)
});